import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=601a54b0&"
import script from "./TagSelect.vue?vue&type=script&lang=ts&"
export * from "./TagSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VIcon,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('601a54b0')) {
      api.createRecord('601a54b0', component.options)
    } else {
      api.reload('601a54b0', component.options)
    }
    module.hot.accept("./TagSelect.vue?vue&type=template&id=601a54b0&", function () {
      api.rerender('601a54b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tags/TagSelect.vue"
export default component.exports